import React from "react";


import clsx from "clsx";
import {useDispatch, useSelector} from "react-redux";
import {createPayout, redirectToStripeAccount} from "../../../store/entities/App/App.actions";
import {selectProfileInfo} from "../../../store/selectors/Profile";
import {selectBalance, selectPayoutsLost} from "../../../store/selectors/App";
import Button from '../../Common/Buttons/small'
import Toast from "../../Common/Toast";
import ToastMessage from "../../Common/ToastMessage";
const PaymentControlBar = () => {
  const dispatch = useDispatch();
  const profileInfo = useSelector(selectProfileInfo);
  const totalBalance = useSelector(selectBalance);
  const payoutsLost = useSelector(selectPayoutsLost);

  const username=`${profileInfo.firstName} ${profileInfo.secondName}`;

  const redirectToStripe = () => {
    dispatch(redirectToStripeAccount())
  }

  const callback = () => {
      Toast(ToastMessage(7), "success")
  }

  const errorCallback = (e) => {
      Toast(`${e.response.data.message}`, "error")
  }

  const handleCreatePayout = () => {
    dispatch(createPayout(callback, errorCallback))
  }

  return (
    <div className={"containers "}>
      <div className="desktopHeader">
        <div className={clsx("payOutContainer", "directionColumn")}>
          <h2 className={"header EMPHASIS_EXTRA_LARGE"}>{ username }</h2>
          <a className={"link BODY_SMALL"} onClick={redirectToStripe}>
            View Stripe account
          </a>
        </div>

          <div className={"payOutContainer directionColumn middleColumn"}>
                <Button loading={false} handleClick={handleCreatePayout} additionClass={"  payOutBtn"} text={"Pay out now"} disabled={payoutsLost <= 0 || totalBalance > 0}/>
                <p className={"text BODY_SMALL payout-desc"}>
                  {payoutsLost} payouts remaining this month<br/>
                </p>
           </div>

          <div className={clsx("payOutContainer", "directionColumn")}>
            <h2 className={"header EMPHASIS_EXTRA_LARGE"}>{totalBalance.currency && totalBalance.currency.slice(0,2).toUpperCase()}{totalBalance.symbol}{(totalBalance.amount).toFixed(2)}</h2>
            <span className="text BODY_SMALL">Your balance</span>
          </div>
        </div>
        <div className="mobileHeaderPayments">
           <div className="fullwidthCenter">
               <h1 className="H1">Payments</h1>
           </div>
           <div className="inputContainerMobile">
             <div className={"payOutContainer directionColumn middleColumn"}>
                <Button loading={false} handleClick={handleCreatePayout} additionClass={"  payOutBtn"} text={"Pay out now"} disabled={payoutsLost <= 0 || totalBalance > 0}/>
                <p className={"text BODY_SMALL payout-desc"}>
                  {payoutsLost} pay-out’s remaining this month<br/>
                </p>
              </div>
              <div className="fullwidthCenter">
                <div className={clsx("payOutContainer", "directionColumn")}>
                    <h2 className={"header EMPHASIS_EXTRA_LARGE"}>{ username }</h2>
                    <a className={"link BODY_SMALL"} onClick={redirectToStripe}>
                      View Stripe account
                    </a>
                </div>
                <div className={clsx("payOutContainer", "directionColumn")}>
                    <h2 className={"header EMPHASIS_EXTRA_LARGE"}>{totalBalance.currency && totalBalance.currency.slice(0,2).toUpperCase()}{totalBalance.symbol}{(totalBalance.amount).toFixed(2)}</h2>
                    <span className="text BODY_SMALL">Your balance</span>
                  </div>
              </div>
           </div>


        </div>
    </div>
  );
}

export default PaymentControlBar;
